import React, {useState, useEffect} from "react";
import {useParams} from "react-router-dom";
import templateService from "../../../services/template.service";
import {toast} from "react-toastify";
import clinicService from "../../../services/clinic.service";

const SelectedTemplateList = ({templateList, handleRemove}) => {
    const toProperCase = (inputString) => {
        let words = inputString.split("_");
        let properCaseString = words
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ");

        return properCaseString;
    };
    return (
        <>
            <ul className="list-group mb-3">
                {templateList.map((tem) => {
                    return (
                        <>
                            <li
                                className="list-group-item d-flex justify-content-between align-items-center"
                                key={tem.templateId}
                            >
                                <div>
                                    <div className="h5">{toProperCase(tem.templateName)}</div>
                                    {tem.isPresent ? (
                                        <span className="text-danger">
                                          <small>Attension: This will reset to default.</small>
                                        </span>
                                    ) : (
                                        ""
                                    )}
                                </div>
                                <button
                                    className="btn btn-sm btn-secondary"
                                    onClick={() => handleRemove(tem.templateId)}
                                >
                                    x
                                </button>
                            </li>
                        </>
                    );
                })}
            </ul>
        </>
    );
};

function LoadTemplate() {
    const {clinicId, type} = useParams();
    const [selectedTemplate, setSelectedTemplate] = useState([]);
    const [ecxTemplateList, setEcxTemplateList] = useState([]);
    const [clinicTemplateList, setClinicTemplateList] = useState([]);
    const [clinicTemplateTypeArray, setClinicTemplateTypeArray] = useState();
    const [clinicInfo, setClinicInfo] = useState();

    useEffect(() => {
        if (type === "email") {
            getClinicEmailTemplate();
        }
        if (type === "sms") {
            getClinicSmsTemplate();
        }
        if (type === "call") {
            getClinicCallTemplate();
        }
        getEcxTemplates();
        getClinicInfo(clinicId);
    }, []);

    const getEcxTemplates = () => {
        setEcxTemplateList([]);
        const templateType = type.toUpperCase();
        templateService
            .getEcxTemplate(1, templateType, 0, 50)
            .then((res) => {
                setEcxTemplateList(res.data.content);
            })
            .catch((err) => {
                console.log("Error in Template List");
                console.log(err);
            });
    };
    const getClinicEmailTemplate = () => {
        setClinicTemplateList([]);
        templateService
            .getEmailTemplate(clinicId)
            .then((res) => {
                setClinicTemplateList(res.data);
                let ctype = res.data.map((obj) => obj.type);
                setClinicTemplateTypeArray(ctype);
            })
            .catch((err) => {
                if (err.response.status === 404) {
                    setClinicTemplateList([]);
                    console.log(err.response.data.error);
                    toast.error(err.response.data.error, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                } else {
                    console.log(err);
                }
            });
    };
    const getClinicSmsTemplate = () => {
        setClinicTemplateList([]);
        templateService
            .getSmsTemplate(clinicId)
            .then((res) => {
                setClinicTemplateList(res.data);
                let ctype = res.data.map((obj) => obj.type);
                setClinicTemplateTypeArray(ctype);
            })
            .catch((err) => {
                if (err.response.status === 404) {
                    setClinicTemplateList([]);
                    console.log(err.response.data.error);
                    toast.error(err.response.data.error, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                } else {
                    console.log(err);
                }
            });
    };
    const getClinicCallTemplate = () => {
        setClinicTemplateList([]);
        templateService
            .getCallTemplate(clinicId)
            .then((res) => {
                setClinicTemplateList(res.data);
                let ctype = res.data.map((obj) => obj.type);
                setClinicTemplateTypeArray(ctype);
            })
            .catch((err) => {
                if (err.response.status === 404) {
                    setClinicTemplateList([]);
                    console.log(err.response.data.error);
                    toast.error(err.response.data.error, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                } else {
                    console.log(err);
                }
            });
    };
    const getClinicInfo = (cid) => {
        setClinicInfo(null);
        clinicService
            .getClinicById(cid)
            .then((res) => {
                setClinicInfo(res.data);
            })
            .catch((err) => {
                console.log("Error while Getting Clinic INfo");
            });
    };

    const loadTemplate = () => {
        if (selectedTemplate.length > 0) {
            let ecxTemplateIds = selectedTemplate.map((obj) => obj.templateId);
            let clientClinicId = clinicId;
            const data = {ecxTemplateIds, clientClinicId};
            templateService
                .loadTemplates(1, data)
                .then((res) => {
                    setSelectedTemplate([]);
                    toast.success("Templates Loaded Successfully. Refresh the page", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                })
                .catch((err) => {
                    toast.error("Error While Loading Templates", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    console.log(err);
                });
        }
    };

    const toProperCase = (inputString) => {
        let words = inputString.split("_");
        let properCaseString = words
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ");
        return properCaseString;
    };

    const handleSelect = (templateName, templateId, isPresent) => {
        let selectedTID = selectedTemplate.map((obj) => obj.templateName);
        if (!selectedTID.includes(templateName)) {
            let tobj = {templateName, templateId, isPresent};
            setSelectedTemplate([...selectedTemplate, tobj]);
        }
    };
    const handleSelectRemove = (templateId) => {
        const filteredItems = selectedTemplate.filter(
            (item) => item.templateId !== templateId
        );
        setSelectedTemplate(filteredItems);
    };

    const handleClear = () => {
        setSelectedTemplate([]);
    };
    return (
        <>
            <div className="container container-xxl">
                <div className="pagetitle d-flex justify-content-between">
                    <h1>Load Template Into {clinicInfo && clinicInfo.name}</h1>
                    <div></div>
                </div>
                <div className="row">
                    <div className="col-sm-8">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">Templates ({type})</h5>
                                <ul className="list-group mt-1">
                                    {ecxTemplateList &&
                                        ecxTemplateList.map((template) => {
                                            let inClinic = false;
                                            if (
                                                clinicTemplateTypeArray &&
                                                clinicTemplateTypeArray.includes(template.type)
                                            ) {
                                                inClinic = true;
                                            }
                                            return (
                                                <li
                                                    className="list-group-item d-flex justify-content-between align-items-center"
                                                    key={template.id}
                                                >
                                                    {inClinic ? (
                                                        <>
                                                            <div>
                                                                <div className="h5">
                                                                    {toProperCase(template.type)}
                                                                </div>
                                                                <span className="text-danger">
                                  <small>
                                    Present in Clinic. Reset to Overide
                                  </small>
                                </span>
                                                            </div>
                                                            <button
                                                                className="btn btn-md btn-warning"
                                                                onClick={() =>
                                                                    handleSelect(template.type, template.id, true)
                                                                }
                                                            >
                                                                Reset
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div>
                                                                <div className="h5">
                                                                    {toProperCase(template.type)}
                                                                </div>
                                                                <span>
                                  <small>Not assigned to Clinic. Add it</small>
                                </span>
                                                            </div>
                                                            <button
                                                                className="btn btn-md btn-secondary"
                                                                onClick={() =>
                                                                    handleSelect(
                                                                        template.type,
                                                                        template.id,
                                                                        false
                                                                    )
                                                                }
                                                            >
                                                                Add
                                                            </button>
                                                        </>
                                                    )}
                                                </li>
                                            );
                                        })}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">Selected Template</h5>
                                {selectedTemplate.length > 0 ? (
                                    <>
                                        <SelectedTemplateList
                                            templateList={selectedTemplate}
                                            handleRemove={handleSelectRemove}
                                        />
                                        <button
                                            className="btn btn-sm btn-success"
                                            onClick={() => loadTemplate()}
                                        >
                                            Load Templates
                                        </button>
                                        <button
                                            className="btn btn-sm btn-secondary ms-2"
                                            onClick={() => handleClear()}
                                        >
                                            Clear
                                        </button>
                                    </>
                                ) : (
                                    ""
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LoadTemplate;
